import { I as Icon, _ as _extends } from './Icon-f29ff1c6.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Profile = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M12 12c2.4862 0 4.5-2.0137 4.5-4.5S14.4862 3 12 3C9.5137 3 7.5 5.0137 7.5 7.5S9.5137 12 12 12zm0 2.25c-3.0038 0-9 1.5075-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.9925-5.9963-4.5-9-4.5z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M12 10c1.3817 0 2.5-1.1183 2.5-2.5S13.3817 5 12 5 9.5 6.1183 9.5 7.5 10.6183 10 12 10zm-7 8.749V19h14v-.251c.0002-.0191.002-.179-.3403-.4949-.363-.335-.9618-.6931-1.777-1.0197C15.249 16.58 13.2519 16.25 12 16.25s-3.249.33-4.8827.9844c-.8152.3266-1.414.6847-1.777 1.0197-.3423.3159-.3405.4758-.3403.4949zM16.5 7.5c0 2.4863-2.0138 4.5-4.5 4.5-2.4863 0-4.5-2.0137-4.5-4.5S9.5137 3 12 3c2.4862 0 4.5 2.0137 4.5 4.5zM3 18.75c0-2.9925 5.9962-4.5 9-4.5 3.0037 0 9 1.5075 9 4.5v1.75a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-1.75z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Profile.displayName = "ProfileIcon";

export { Profile, Profile as default };
